import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { CompetencyFilterOptionData } from '../../../../../Types';
import {
  blank,
  closed,
  CompetencyFilter,
  CompetencyFilterOptions,
  opened,
  State,
  updatingCompetency,
} from './Types';

class CompetencyFilterStore {
  @observable
  state: State;

  readonly initialFilterValues: CompetencyFilter;

  constructor(filters: CompetencyFilterOptionData[]) {
    makeObservable(this);
    this.initialFilterValues = {
      competencies: filters.map((d) => d.name),
    };

    this.state = blank(this.initialFilterValues);
  }

  @action
  open = () => {
    switch (this.state.kind) {
      case 'closed':
        this.state = opened(this.state);
        break;
      case 'opened':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  close = () => {
    switch (this.state.kind) {
      case 'opened':
        this.state = closed(this.state);
        break;
      case 'closed':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  filterAllValues = (value: CompetencyFilterOptions) => {
    switch (this.state.kind) {
      case 'opened':
        this.state = updatingCompetency(this.state, value, this.initialFilterValues.competencies);
        break;
      case 'closed':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default CompetencyFilterStore;
